export default __webpack_public_path__ + "static/sam42_sales-c7f2174daf8be8f5935bb34843fd1576.jpg";